var _circle, _g, _circle2, _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLightNoNetBundle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#uwu3ey5dxa)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 18,
    fill: "#F4E2F3"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 19.5,
    stroke: "url(#wmivwxicyb)",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 31c3.194 3.069 7.834 5 13 5s9.806-1.931 13-5",
    stroke: "#BD55B8",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 57c3.194-3.069 7.834-5 13-5s9.806 1.931 13 5",
    stroke: "#9C4EB2",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44 63.5c3.553 0 6.455-2.575 8.382-6.044C54.338 53.936 55.5 49.176 55.5 44s-1.162-9.937-3.118-13.456C50.455 27.074 47.554 24.5 44 24.5c-3.553 0-6.455 2.575-8.382 6.044C33.662 34.064 32.5 38.824 32.5 44s1.162 9.937 3.118 13.456C37.545 60.926 40.446 63.5 44 63.5z",
    stroke: "url(#z5xcsqu7kc)",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44 25v37.5M63 44H24.5",
    stroke: "#BD55B8",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wmivwxicyb",
    x1: 44,
    y1: 26,
    x2: 44,
    y2: 62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D95BBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C4AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z5xcsqu7kc",
    x1: 44,
    y1: 26,
    x2: 44,
    y2: 62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D95BBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C4AAF"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "uwu3ey5dxa",
    x: 23,
    y: 23,
    width: 42,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.905882 0 0 0 0 0.752941 0 0 0 0 0.894118 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_2093_19913"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_innerShadow_2093_19913",
    result: "effect2_innerShadow_2093_19913"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightNoNetBundle);
export default __webpack_public_path__ + "static/media/lightNoNetBundle.46d09cf10a71b365f32c63031cf757f1.svg";
export { ForwardRef as ReactComponent };